export const SECURITY_LEVELS = {
  devicekey: { level: 4, label: 'Very strong security' },
  fidokey: { level: 4, label: 'Very strong security' },
  yubikey: { level: 4, label: 'Very strong security' },
  generator: { level: 3, label: 'Strong security' },
  push: { level: 2, label: 'Moderate security' },
  phone: { level: 1, label: 'Fair security' },
  backupcodes: { level: 1, label: 'Fair security' },
  recovery: { level: 1, label: 'Fair security' },
};
